import { useAPI } from 'src/hooks';
import { useDebouncedCallback } from 'use-debounce';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import loadable from '@loadable/component';

const ErrorMsg = loadable(() => import('@com/utils/ErrorMsg'));
const Footer = loadable(() => import('@com/footer/Footer'));
const FullSectionText = loadable(() => import('@com/FullSectionText'));
const Header = loadable(() => import('@com/header/Header'));
const TopSection = loadable(() => import('@com/TopSection'));

interface FormInputs {
  email: string;
}
function ForgetPassword(): JSX.Element {
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm<FormInputs>();
  const { t } = useTranslation();
  const { sendResetPasswordEmail } = useAPI();

  const onSubmit = useDebouncedCallback(
    async (_data: FormInputs) => {
      const hasSent = await sendResetPasswordEmail(_data.email);
      if (hasSent) setIsSuccess(true);
    },
    500,
    { leading: true, trailing: false }
  );
  return (
    <>
      <Header />
      <TopSection sectionName={t('loginPage.forgetPassword')} />
      {!isSuccess ? (
        <section className="content-container tf-login tf-section">
          <div className="themesflat-container min-h-50">
            <div className="px-5">
              <div className="flat-form box-login-email">
                <div className="form-inner">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <input
                      aria-required
                      aria-label="email"
                      data-test="for-pass-email"
                      placeholder={t('signUpPage.yourEmailAddress')}
                      type="text"
                      {...register('email', {
                        required: {
                          value: true,
                          message: t('errorMsg.register.emailRequired'),
                        },
                        pattern: {
                          value:
                            /^\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\s*$/i,
                          message: t('errorMsg.register.emailPattern'),
                        },
                      })}
                    />
                    <ErrorMsg errors={errors} name="email" />
                    <button
                      className="mt-5"
                      data-test="reset-pwd-btn"
                      type="submit"
                    >
                      {t('signUpPage.resetPasswordViaEmail')}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <FullSectionText>
          <>
            <div>{t('signUpPage.resetPasswordEmailSent')}</div>
            <br />
            <br />
            <h3>{getValues('email')}</h3>
            <br />
            <div className="">{t('signUpPage.pleaseCheckEmail')}</div>
          </>
        </FullSectionText>
      )}

      <Footer />
    </>
  );
}

export default ForgetPassword;
